import { render, staticRenderFns } from "./VehicleDiagram.vue?vue&type=template&id=1cbaa384&scoped=true"
import script from "./VehicleDiagram.vue?vue&type=script&lang=js"
export * from "./VehicleDiagram.vue?vue&type=script&lang=js"
import style0 from "./VehicleDiagram.vue?vue&type=style&index=0&id=1cbaa384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbaa384",
  null
  
)

export default component.exports